<template>
  <Head title="Il ristorante" />
  <h2 class="text-3xl leading-tight font-bold">Il ristorante</h2>
  <!--  <p class="text-lg mt-4 font-semibold">WIP</p>-->
  <p class="mt-2 leading-relaxed">
    Benvenuti nel nostro ristorante all'aperto presso la piscina! Qui nel nostro splendido locale, vi offriamo
    un'esperienza culinaria unica che si sposa perfettamente con la bellezza naturale circostante.
  </p>
  <p class="mt-2 leading-relaxed">
    Il nostro menu è stato accuratamente progettato per soddisfare ogni gusto e desiderio. Dalle fresche insalate estive
    ai piatti principali succulenti, troverete una vasta selezione di delizie gastronomiche che vi faranno venire
    l'acquolina in bocca. Gustatevi i nostri panini gourmet preparati con ingredienti freschi e di alta qualità, oppure
    deliziatevi con le nostre pizze appena sfornate, croccanti e ricche di sapore.
  </p>
  <p class="mt-2 leading-relaxed">
    Non dimenticate di accompagnare il vostro pasto con una delle nostre bevande rinfrescanti, preparate al momento dai
    nostri baristi esperti. Dai cocktail classici alle creazioni originali, c'è qualcosa per tutti i gusti. E per i più
    piccoli, abbiamo un'ampia selezione di bevande analcoliche e succhi di frutta per mantenere alta la loro energia
    durante il divertimento in piscina.
  </p>

  <p class="mt-2 leading-relaxed">
    Immergetevi nella nostra atmosfera rilassante e godetevi la compagnia degli amici e della famiglia mentre
    sorseggiate una bibita o assaporate un delizioso pasto. La nostra terrazza all'aperto offre una vista mozzafiato
    sulla piscina e sulle verdi colline circostanti, creando un'atmosfera incantevole che renderà la vostra esperienza
    indimenticabile.
  </p>
  <p class="mt-2 leading-relaxed">
    Sia che siate qui per una giornata di relax al sole o per una serata di divertimento con gli amici, il nostro
    ristorante all'aperto è il luogo perfetto per godersi il meglio dell'estate italiana. Vi aspettiamo per deliziarvi
    con i sapori autentici e l'ospitalità calorosa che solo il nostro locale può offrire!
  </p>
</template>

<script>
import Header from "@/Pages/Home/Shared/Header.vue";
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Header,
    Head,
  },
  layout: PageLayout,
};
</script>
